/* eslint-disable no-console -- logger */
import {
  getEmirateFromGoogleAddress,
  getTownFromGoogleAddress,
} from "../components/Address/MapSheet/Address.helper";
import type { ISetFormattedAddressFromCoordinatesProps } from "../types";

interface IGeocodeResults {
  lat: number;
  lng: number;
  results: google.maps.GeocoderResult[];
}

const getCachedGeocodeResults = (): IGeocodeResults | null => {
  const storedResults = localStorage.getItem("geocode_results");
  if (storedResults) {
    try {
      return JSON.parse(storedResults) as IGeocodeResults;
    } catch (e) {
      console.error("Failed to parse stored geocode results", e);
    }
  }
  return null;
};

export const setFormattedAddressFromCoordinates = ({
  lat,
  lng,
  forceUpdate,
  setAddressInfo,
  setEmirate,
  setTown,
  checkAreaSupport,
}: ISetFormattedAddressFromCoordinatesProps): void => {
  const geocoder = new window.google.maps.Geocoder();
  const parsedResults = getCachedGeocodeResults();
  if (
    !parsedResults ||
    (parsedResults.lat !== lat && parsedResults.lng !== lng) ||
    forceUpdate
  ) {
    geocoder
      .geocode({ location: { lat, lng } })
      .then((response) => {
        const results = response.results;
        if (results.length) {
          setAddressInfo?.(
            results[1]?.formatted_address || results[0]?.formatted_address,
          );
          setEmirate?.(getEmirateFromGoogleAddress(results[0]));
          setTown?.(getTownFromGoogleAddress(results[0]));
          localStorage.setItem(
            "geocode_results",
            JSON.stringify({ results, lat, lng }),
          );
          checkAreaSupport(lat, lng);
        } else {
          console.error("No results found");
        }
      })
      .catch((status: string) => {
        console.error(`Geocoder failed due to: ${status}`);
      });
  } else {
    const { results = [] } = parsedResults;
    console.info("Using cached results", results);
  }
};
